export default function ContactForm() {
  const setup = (form) => {
    const submit = form.querySelector('button[type="submit"]');
    const inputs = form.querySelectorAll('[required]');

    const validate = () => {
      let validCount = 0;
      inputs.forEach((_input) => {
        _input.checkValidity() && validCount++;
      });
      if (validCount === inputs.length) {
        submit.removeAttribute('disabled');
      } else {
        submit.setAttribute('disabled', 'disabled');
      }
    };

    const onChange = (e) => {
      const input = e.target;

      if (input.value !== '' && !input.checkValidity()) {
        input.parentElement.classList.add('w-has-error');
      } else {
        input.parentElement.classList.remove('w-has-error');
      }

      validate();
    };
    inputs.forEach((input) => {
      input.addEventListener('keyup', onChange);
      input.addEventListener('change', onChange);
    });

    const onSubmit = (e) => {
      e.preventDefault();

      let valid = true;
      inputs.forEach((input) => {
        if (!input.checkValidity()) {
          valid = false;
          input.parentElement.classList.add('w-has-error');
        }
      });

      if (!valid) return false;
      else {
        let method = form.getAttribute('method');
        let url = form.getAttribute('action');

        if (!method) return;
        if (!url) url = document.location.href;

        let formData = new FormData(form);

        fetch(url, {
          method: method.toUpperCase(),
          body: formData,
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
        })
          .then((response) => response.json())
          .then((data) => {
            if (data && data.success === true) {
              if (data.redirect) {
                document.location.href = data.redirect;
              }
            }
          })
          .catch((error) => {
            // setStatus(form, 'idle');
            doError(form, error, this.controller);
          });
      }
    };

    submit.addEventListener('click', onSubmit);

    validate();
  };

  return {
    init: () => {
      const form = document.querySelector('[data-w-form="contact"]');
      if (!form) return;

      setup(form);
    },
  };
}
